// extracted by mini-css-extract-plugin
export var orderDetails = "_o3-2";
export var orderImage = "_o3-1";
export var orderMeta = "_o3-3";
export var orderSummary = "_o3-0";
export var rightArrow = "_o3-4";